<template>
  <le-dialog title="选择监视器节点" custom-class="le-select-node-dialog" :visible.sync="dialogShowStatus" :modal="false" width="800px" :append-to-body="false">
    <div class="le-select-node-con">
      <div class="le-job-header">
        <el-input v-model="searchForm.keyWord" placeholder="请输入监视器名称或IP查询" prefix-icon="el-icon-search" :clearable="true" @input="handleInputEvent" />
      </div>

      <div class="le-job-body le-job-height">
        <div v-if="page.records.length > 0" class="le-job-row">
          <div class="le-job-items">
            <div v-for="item in page.records" :key="item.id || item.idField" draggable="true" class="le-tp-job-group" @dragstart="handleDragStartEvent($event, item)">
              <div class="le-tp-job-con">
                <div class="le-job-icon">
                  <i class="tp-icon lt" :class="item.iconContent" />
                </div>
                <span class="tp-job-txt">{{ item.label }}</span>
                <span class="tp-job-txt">{{ item.ipAddress }}</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="page.total > 0" class="le-job-row">
          <div class="le-job-paging">
            <el-pagination
              class="le-paging"
              :background="true"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :page-sizes="[20, 40, 80, 160, 240, 500]"
              :total="page.total"
              layout="prev, pager, next, total, sizes, jumper"
              @current-change="handleCurrentChangeEvent"
              @size-change="handleSizeChangeEvent" />
          </div>
        </div>

        <div v-if="page.records.length === 0" class="le-tp-empty">
          <el-empty description="无监视器数据" />
        </div>
      </div>
    </div>
  </le-dialog>
</template>

<script>
import {identityConst} from '../../scripts/conf';
import {coreUtil} from '../../../../static/scripts/util';
import {listTpJobByIdentity} from '../../scripts/data';

export default {
  name: 'LeTpJob',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    elementIdentity: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        identity: '',
        keyWord: ''
      },
      page: {
        total: 0,
        records: []
      }
    };
  },
  computed: {
    dialogShowStatus: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    elementIdentity: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.searchForm.identity = newVal;
          this.loadJobByIdentity();
        }
      },
      immediate: true
    }
  },
  methods: {
    loadJobByIdentity() {
      listTpJobByIdentity(this.searchForm).then(resp => {
        const {total, records} = resp.data;
        this.page.total = total;
        this.page.records = records;
        this.page.records?.forEach(item => {
          item.size = coreUtil.parseJson(item.size);
          item.style = coreUtil.parseJson(item.style);
          item.labelCfg = coreUtil.parseJson(item.labelCfg);
          item.anchorPoints = coreUtil.parseJson(item.anchorPoints);
          // 如果后台接口响应的是 idField 和 typeField，单独处理增强兼容性
          item.id = item.id || item.idField;
          item.type = item.type || item.typeField;
        });
      });
    },
    handleInputEvent(keyWord) {
      this.searchForm.keyWord = keyWord?.trim();
      this.loadJobByIdentity();
    },
    handleCurrentChangeEvent(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.loadJobByIdentity();
    },
    handleSizeChangeEvent(pageSize) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = pageSize;
      this.loadJobByIdentity();
    },
    handleDragStartEvent(evt, attrs) {
      // 拖动组件开始
      const data = {
        eleId: attrs?.elementId,
        elementIdentity: this.elementIdentity,
        moduleIdentity: identityConst.componentInfoJob,
        elementAttr: attrs
      };

      console.log(data, '弹窗往右拖准备生成');
      evt.dataTransfer.setData('tp:element:ShapeAttribute', JSON.stringify(data));
    }
  }
};
</script>

<style scoped>

</style>
